const vobbLocations = [
  { region: 'CENTRAL', chargeArea: 'BANTING', exchangeArea: 'BATANG PADANG' },
  { region: 'CENTRAL', chargeArea: 'BANTING', exchangeArea: 'KUALA LANGAT' },
  { region: 'CENTRAL', chargeArea: 'BATU ARANG', exchangeArea: 'BANDAR SG. BUAYA' },
  { region: 'CENTRAL', chargeArea: 'CHERAS', exchangeArea: 'CHERAS' },
  { region: 'CENTRAL', chargeArea: 'CHERAS', exchangeArea: 'SERDANG' },
  { region: 'CENTRAL', chargeArea: 'GOMBAK', exchangeArea: 'GOMBAK' },
  { region: 'CENTRAL', chargeArea: 'HULU LANGAT', exchangeArea: 'HULU LANGAT' },
  { region: 'CENTRAL', chargeArea: 'HULU SELANGOR', exchangeArea: 'HULU SELANGOR' },
  { region: 'CENTRAL', chargeArea: 'KELANG', exchangeArea: 'KELANA JAYA' },
  { region: 'CENTRAL', chargeArea: 'KELANG', exchangeArea: 'KELANG' },
  { region: 'CENTRAL', chargeArea: 'KINRARA', exchangeArea: 'PUCHONG' },
  { region: 'CENTRAL', chargeArea: 'KINRARA', exchangeArea: 'SHAH ALAM' },
  { region: 'CENTRAL', chargeArea: 'KINRARA', exchangeArea: 'USJ' },
  { region: 'CENTRAL', chargeArea: 'KLANG', exchangeArea: 'KLANG' },
  { region: 'CENTRAL', chargeArea: 'KUALA LANGAT', exchangeArea: 'KUALA LANGAT' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'AMPANG' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'CHERAS' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'GOMBAK' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'KELANA JAYA' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'KUALA LUMPUR' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'PETALING JAYA' },
  { region: 'CENTRAL', chargeArea: 'KUALA LUMPUR', exchangeArea: 'SUBANG AIRPORT' },
  { region: 'CENTRAL', chargeArea: 'KUALA SELANGOR', exchangeArea: 'KUALA SELANGOR' },
  { region: 'CENTRAL', chargeArea: 'PETALING', exchangeArea: 'PETALING' },
  { region: 'CENTRAL', chargeArea: 'PETALING', exchangeArea: 'PETALING JAYA' },
  { region: 'CENTRAL', chargeArea: 'PUTRAJAYA', exchangeArea: 'PUTRAJAYA' },
  { region: 'CENTRAL', chargeArea: 'SABAK BERNAM', exchangeArea: 'SABAK BERNAM' },
  { region: 'CENTRAL', chargeArea: 'SEMENYIH', exchangeArea: 'SALAK TINGGI' },
  { region: 'CENTRAL', chargeArea: 'SEPANG', exchangeArea: 'BAGAN LALANG' },
  { region: 'CENTRAL', chargeArea: 'SEPANG', exchangeArea: 'SEPANG' },
  { region: 'EASTERN', chargeArea: 'BACHOK', exchangeArea: 'BACHOK' },
  { region: 'EASTERN', chargeArea: 'BENTONG', exchangeArea: 'BENTONG' },
  { region: 'EASTERN', chargeArea: 'BERA', exchangeArea: 'BERA' },
  { region: 'EASTERN', chargeArea: 'BESUT', exchangeArea: 'BESUT' },
  { region: 'EASTERN', chargeArea: 'CHUKAI', exchangeArea: 'KEMAMAN' },
  { region: 'EASTERN', chargeArea: 'DUNGUN', exchangeArea: 'DUNGUN' },
  { region: 'EASTERN', chargeArea: 'GUA MUSANG', exchangeArea: 'GUA MUSANG' },
  { region: 'EASTERN', chargeArea: 'HULU TERENGGANU', exchangeArea: 'HULU TERENGGANU' },
  { region: 'EASTERN', chargeArea: 'JELI', exchangeArea: 'JELI' },
  { region: 'EASTERN', chargeArea: 'JERANTUT', exchangeArea: 'JERANTUT' },
  { region: 'EASTERN', chargeArea: 'KEMAMAN', exchangeArea: 'KEMAMAN' },
  { region: 'EASTERN', chargeArea: 'KOTA BHARU', exchangeArea: 'KOTA BHARU' },
  { region: 'EASTERN', chargeArea: 'KUALA BERANG', exchangeArea: 'KUALA TERENGGANU' },
  { region: 'EASTERN', chargeArea: 'KUALA KERAI', exchangeArea: 'KUALA KERAI' },
  { region: 'EASTERN', chargeArea: 'KUALA KRAI', exchangeArea: 'KUALA KRAI' },
  { region: 'EASTERN', chargeArea: 'KUALA TERENGGANU', exchangeArea: 'KUALA TERENGGANU' },
  { region: 'EASTERN', chargeArea: 'KUANTAN', exchangeArea: 'KUANTAN' },
  { region: 'EASTERN', chargeArea: 'LIPIS', exchangeArea: 'LIPIS' },
  { region: 'EASTERN', chargeArea: 'MACHANG', exchangeArea: 'MACHANG' },
  { region: 'EASTERN', chargeArea: 'MARAN', exchangeArea: 'MARAN' },
  { region: 'EASTERN', chargeArea: 'MARANG', exchangeArea: 'MARANG' },
  { region: 'EASTERN', chargeArea: 'MENTAKAB', exchangeArea: 'TEMERLOH' },
  { region: 'EASTERN', chargeArea: 'PAKA', exchangeArea: 'PAKA' },
  { region: 'EASTERN', chargeArea: 'PASIR MAS', exchangeArea: 'PASIR MAS' },
  { region: 'EASTERN', chargeArea: 'PASIR PUTEH', exchangeArea: 'PASIR PUTEH' },
  { region: 'EASTERN', chargeArea: 'PEKAN', exchangeArea: 'PEKAN' },
  { region: 'EASTERN', chargeArea: 'RAUB', exchangeArea: 'RAUB' },
  { region: 'EASTERN', chargeArea: 'ROMPIN', exchangeArea: 'ROMPIN' },
  { region: 'EASTERN', chargeArea: 'SETIU', exchangeArea: 'SETIU' },
  { region: 'EASTERN', chargeArea: 'TEMERLOH', exchangeArea: 'TEMERLOH' },
  { region: 'EASTERN', chargeArea: 'TUMPAT', exchangeArea: 'TUMPAT' },
  { region: 'NORTHERN', chargeArea: 'ALOR SETAR', exchangeArea: 'ALOR SETAR' },
  { region: 'NORTHERN', chargeArea: 'ARAU', exchangeArea: 'ARAU' },
  { region: 'NORTHERN', chargeArea: 'BAGAN DATUK', exchangeArea: 'BAGAN DATUK' },
  { region: 'NORTHERN', chargeArea: 'BALING', exchangeArea: 'BALING' },
  { region: 'NORTHERN', chargeArea: 'BARAT DAYA PULAU PINANG', exchangeArea: 'BARAT DAYA PULAU PINANG' },
  { region: 'NORTHERN', chargeArea: 'BATANG PADANG', exchangeArea: 'BATANG PADANG' },
  { region: 'NORTHERN', chargeArea: 'CAMERON HIGHLANDS', exchangeArea: 'CAMERON HIGHLANDS' },
  { region: 'NORTHERN', chargeArea: 'HILIR PERAK', exchangeArea: 'HILIR PERAK' },
  { region: 'NORTHERN', chargeArea: 'HULU PERAK', exchangeArea: 'HULU PERAK' },
  { region: 'NORTHERN', chargeArea: 'IPOH', exchangeArea: 'IPOH' },
  { region: 'NORTHERN', chargeArea: 'IPOH', exchangeArea: 'JELAPANG MAJU' },
  { region: 'NORTHERN', chargeArea: 'KAKI BUKIT', exchangeArea: 'KAKI BUKIT' },
  { region: 'NORTHERN', chargeArea: 'KAMPAR', exchangeArea: 'KAMPAR' },
  { region: 'NORTHERN', chargeArea: 'KANGAR', exchangeArea: 'KANGAR' },
  { region: 'NORTHERN', chargeArea: 'KEPALA BATAS', exchangeArea: 'KEPALA BATAS' },
  { region: 'NORTHERN', chargeArea: 'KERIAN', exchangeArea: 'KERIAN' },
  { region: 'NORTHERN', chargeArea: 'KINTA', exchangeArea: 'KINTA' },
  { region: 'NORTHERN', chargeArea: 'KOTA SETAR', exchangeArea: 'KOTA SETAR' },
  { region: 'NORTHERN', chargeArea: 'KUAH', exchangeArea: 'LANGKAWI' },
  { region: 'NORTHERN', chargeArea: 'KUALA KANGSAR', exchangeArea: 'KUALA KANGSAR' },
  { region: 'NORTHERN', chargeArea: 'KUALA MUDA', exchangeArea: 'KUALA MUDA' },
  { region: 'NORTHERN', chargeArea: 'KUALA NERUS', exchangeArea: 'KUALA NERUS' },
  { region: 'NORTHERN', chargeArea: 'KUALA PERLIS', exchangeArea: 'KUALA PERLIS' },
  { region: 'NORTHERN', chargeArea: 'KUBANG PASU', exchangeArea: 'KUBANG PASU' },
  { region: 'NORTHERN', chargeArea: 'KULIM', exchangeArea: 'KULIM' },
  { region: 'NORTHERN', chargeArea: 'LABUAN', exchangeArea: 'LABUAN' },
  { region: 'NORTHERN', chargeArea: 'LANGKAWI', exchangeArea: 'LANGKAWI' },
  { region: 'NORTHERN', chargeArea: 'LARUT', exchangeArea: 'LARUT' },
  { region: 'NORTHERN', chargeArea: 'LENGGONG', exchangeArea: 'LENGGONG' },
  { region: 'NORTHERN', chargeArea: 'MANJUNG', exchangeArea: 'MANJUNG' },
  { region: 'NORTHERN', chargeArea: 'MENTAKAB', exchangeArea: 'TEMERLOH' },
  { region: 'NORTHERN', chargeArea: 'MUALIM', exchangeArea: 'MUALIM' },
  { region: 'NORTHERN', chargeArea: 'PADANG TERAP', exchangeArea: 'PADANG TERAP' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'BAYAN BARU' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'BUTTERWORTH' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'GEORGETOWN' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'MUTIARA' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'PERDA' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'RELAU' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'TANJUNG TOKONG' },
  { region: 'NORTHERN', chargeArea: 'PENANG', exchangeArea: 'TELUK KUMBAR' },
  { region: 'NORTHERN', chargeArea: 'PENDANG', exchangeArea: 'PENDANG' },
  { region: 'NORTHERN', chargeArea: 'PERAK TENGAH', exchangeArea: 'PERAK TENGAH' },
  { region: 'NORTHERN', chargeArea: 'POKOK SENA', exchangeArea: 'POKOK SENA' },
  { region: 'NORTHERN', chargeArea: 'SEBERANG PERAI SELATAN', exchangeArea: 'SEBERANG PERAI SELATAN' },
  { region: 'NORTHERN', chargeArea: 'SEBERANG PERAI TENGAH', exchangeArea: 'SEBERANG PERAI TENGAH' },
  { region: 'NORTHERN', chargeArea: 'SEBERANG PERAI UTARA', exchangeArea: 'SEBERANG PERAI UTARA' },
  { region: 'NORTHERN', chargeArea: 'SEMANGGOL', exchangeArea: 'TASIK BKT MERAH' },
  { region: 'NORTHERN', chargeArea: 'SIK', exchangeArea: 'SIK' },
  { region: 'NORTHERN', chargeArea: 'SITIAWAN', exchangeArea: 'LUMUT' },
  { region: 'NORTHERN', chargeArea: 'SUNGAI PETANI', exchangeArea: 'SUNGAI PETANI' },
  { region: 'NORTHERN', chargeArea: 'TAIPING', exchangeArea: 'TAIPING' },
  { region: 'NORTHERN', chargeArea: 'TAPAH', exchangeArea: 'TAPAH' },
  { region: 'NORTHERN', chargeArea: 'TASIK GELUGOR', exchangeArea: 'BUKIT MERTAJAM' },
  { region: 'NORTHERN', chargeArea: 'TELOK INTAN', exchangeArea: 'TELOK INTAN' },
  { region: 'NORTHERN', chargeArea: 'TG. MALIM', exchangeArea: 'BEHRANG' },
  { region: 'NORTHERN', chargeArea: 'TIMUR LAUT PULAU PINANG', exchangeArea: 'GEORGETOWN' },
  { region: 'NORTHERN', chargeArea: 'TIMUR LAUT PULAU PINANG', exchangeArea: 'TIMUR LAUT PULAU PINANG' },
  { region: 'NORTHERN', chargeArea: 'YAN', exchangeArea: 'YAN' },
  { region: 'SABAH', chargeArea: 'BEAUFORT', exchangeArea: 'BEAUFORT' },
  { region: 'SABAH', chargeArea: 'BELURAN', exchangeArea: 'BELURAN' },
  { region: 'SABAH', chargeArea: 'ELOPURA', exchangeArea: 'SANDAKAN' },
  { region: 'SABAH', chargeArea: 'FELDA SAHABAT', exchangeArea: 'FELDA SAHABAT' },
  { region: 'SABAH', chargeArea: 'KENINGAU', exchangeArea: 'KENINGAU' },
  { region: 'SABAH', chargeArea: 'KOTA BELUD', exchangeArea: 'KOTA BELUD' },
  { region: 'SABAH', chargeArea: 'KOTA KINABALU', exchangeArea: 'KOTA KINABALU' },
  { region: 'SABAH', chargeArea: 'KOTA MARUDU', exchangeArea: 'KOTA MARUDU' },
  { region: 'SABAH', chargeArea: 'KUDAT', exchangeArea: 'KUDAT' },
  { region: 'SABAH', chargeArea: 'KUALA PENYU', exchangeArea: 'KUALA PENYU' },
  { region: 'SABAH', chargeArea: 'KUNAK', exchangeArea: 'KUNAK' },
  { region: 'SABAH', chargeArea: 'LABUAN', exchangeArea: 'LABUAN' },
  { region: 'SABAH', chargeArea: 'LAHAD DATU', exchangeArea: 'LAHAD DATU' },
  { region: 'SABAH', chargeArea: 'MARUDI', exchangeArea: 'MARUDI' },
  { region: 'SABAH', chargeArea: 'NABAWAN', exchangeArea: 'NABAWAN' },
  { region: 'SABAH', chargeArea: 'PAPAR', exchangeArea: 'PAPAR' },
  { region: 'SABAH', chargeArea: 'PENAMPANG', exchangeArea: 'PENAMPANG' },
  { region: 'SABAH', chargeArea: 'PUTATAN', exchangeArea: 'PUTATAN' },
  { region: 'SABAH', chargeArea: 'RANAU', exchangeArea: 'RANAU' },
  { region: 'SABAH', chargeArea: 'SANDAKAN', exchangeArea: 'SANDAKAN' },
  { region: 'SABAH', chargeArea: 'SEMPORNA', exchangeArea: 'SEMPORNA' },
  { region: 'SABAH', chargeArea: 'SIPITANG', exchangeArea: 'SIPITANG' },
  { region: 'SABAH', chargeArea: 'TAMBUNAN', exchangeArea: 'TAMBUNAN' },
  { region: 'SABAH', chargeArea: 'TAMPARULI', exchangeArea: 'TAMPARULI' },
  { region: 'SABAH', chargeArea: 'TAWAU', exchangeArea: 'TAWAU' },
  { region: 'SABAH', chargeArea: 'TELUPID', exchangeArea: 'TELUPID' },
  { region: 'SABAH', chargeArea: 'TENOM', exchangeArea: 'TENOM' },
  { region: 'SABAH', chargeArea: 'TUARAN', exchangeArea: 'TUARAN' },
  { region: 'SARAWAK', chargeArea: 'BETONG', exchangeArea: 'BETONG' },
  { region: 'SARAWAK', chargeArea: 'BINTULU', exchangeArea: 'BINTULU' },
  { region: 'SARAWAK', chargeArea: 'KANOWIT', exchangeArea: 'KANOWIT' },
  { region: 'SARAWAK', chargeArea: 'KUCHING', exchangeArea: 'KUCHING' },
  { region: 'SARAWAK', chargeArea: 'LAWAS', exchangeArea: 'LAWAS' },
  { region: 'SARAWAK', chargeArea: 'LIMBANG', exchangeArea: 'LIMBANG' },
  { region: 'SARAWAK', chargeArea: 'MARUDI', exchangeArea: 'MARUDI' },
  { region: 'SARAWAK', chargeArea: 'MERADONG', exchangeArea: 'MERADONG' },
  { region: 'SARAWAK', chargeArea: 'MIRI', exchangeArea: 'MIRI' },
  { region: 'SARAWAK', chargeArea: 'MUKAH', exchangeArea: 'MUKAH' },
  { region: 'SARAWAK', chargeArea: 'SAMARAHAN', exchangeArea: 'SAMARAHAN' },
  { region: 'SARAWAK', chargeArea: 'SARATOK', exchangeArea: 'SARATOK' },
  { region: 'SARAWAK', chargeArea: 'SARIKEI', exchangeArea: 'SARIKEI' },
  { region: 'SARAWAK', chargeArea: 'SEMARAHAN', exchangeArea: 'SEMARAHAN' },
  { region: 'SARAWAK', chargeArea: 'SERIAN', exchangeArea: 'SERIAN' },
  { region: 'SARAWAK', chargeArea: 'SIBU', exchangeArea: 'SIBU' },
  { region: 'SARAWAK', chargeArea: 'SIMUNJAN', exchangeArea: 'SIMUNJAN' },
  { region: 'SARAWAK', chargeArea: 'SRI AMAN', exchangeArea: 'BANDAR SRI AMAN' },
  { region: 'SARAWAK', chargeArea: 'SRI AMAN', exchangeArea: 'SRI AMAN' },
  { region: 'SOUTHERN', chargeArea: 'ALOR GAJAH', exchangeArea: 'ALOR GAJAH' },
  { region: 'SOUTHERN', chargeArea: 'BATU PAHAT', exchangeArea: 'BATU PAHAT' },
  { region: 'SOUTHERN', chargeArea: 'BEMBAN', exchangeArea: 'BEMBAN' },
  { region: 'SOUTHERN', chargeArea: 'GELANG PATAH', exchangeArea: 'GELANG PATAH' },
  { region: 'SOUTHERN', chargeArea: 'JASIN', exchangeArea: 'JASIN' },
  { region: 'SOUTHERN', chargeArea: 'JEMPOL', exchangeArea: 'JEMPOL' },
  { region: 'SOUTHERN', chargeArea: 'JOHOR BAHRU', exchangeArea: 'JOHOR BAHRU' },
  { region: 'SOUTHERN', chargeArea: 'JOHOR BAHRU', exchangeArea: 'PASIR GUDANG' },
  { region: 'SOUTHERN', chargeArea: 'KELUANG', exchangeArea: 'KELUANG' },
  { region: 'SOUTHERN', chargeArea: 'KLUANG', exchangeArea: 'KLUANG' },
  { region: 'SOUTHERN', chargeArea: 'KOTA TINGGI', exchangeArea: 'KOTA TINGGI' },
  { region: 'SOUTHERN', chargeArea: 'KUALA PILAH', exchangeArea: 'KUALA PILAH' },
  { region: 'SOUTHERN', chargeArea: 'KULAI', exchangeArea: 'KULAI' },
  { region: 'SOUTHERN', chargeArea: 'MANTIN', exchangeArea: 'NILAI' },
  { region: 'SOUTHERN', chargeArea: 'MELAKA', exchangeArea: 'AYER KEROH' },
  { region: 'SOUTHERN', chargeArea: 'MELAKA', exchangeArea: 'KOTA MELAKA' },
  { region: 'SOUTHERN', chargeArea: 'MELAKA', exchangeArea: 'MERLIMAU' },
  { region: 'SOUTHERN', chargeArea: 'MELAKA TENGAH', exchangeArea: 'MELAKA TENGAH' },
  { region: 'SOUTHERN', chargeArea: 'MERSING', exchangeArea: 'MERSING' },
  { region: 'SOUTHERN', chargeArea: 'MUAR', exchangeArea: 'MUAR' },
  { region: 'SOUTHERN', chargeArea: 'PONTIAN', exchangeArea: 'PONTIAN' },
  { region: 'SOUTHERN', chargeArea: 'PORT DICKSON', exchangeArea: 'PORT DICKSON' },
  { region: 'SOUTHERN', chargeArea: 'REMBAU', exchangeArea: 'REMBAU' },
  { region: 'SOUTHERN', chargeArea: 'SEGAMAT', exchangeArea: 'SEGAMAT' },
  { region: 'SOUTHERN', chargeArea: 'SENAI', exchangeArea: 'SENAI/SKUDAI' },
  { region: 'SOUTHERN', chargeArea: 'SEREMBAN', exchangeArea: 'SENAWANG' },
  { region: 'SOUTHERN', chargeArea: 'SEREMBAN', exchangeArea: 'SEREMBAN' },
  { region: 'SOUTHERN', chargeArea: 'SEREMBAN', exchangeArea: 'SEREMBAN 3' },
  { region: 'SOUTHERN', chargeArea: 'TAMPIN', exchangeArea: 'TAMPIN' },
  { region: 'SOUTHERN', chargeArea: 'TANGGA BATU', exchangeArea: 'MASJID TANAH' },
  { region: 'SOUTHERN', chargeArea: 'TANGGA BATU', exchangeArea: 'TG. MINYAK' },
  { region: 'SOUTHERN', chargeArea: 'TANJUNG KUPANG', exchangeArea: 'TANJUNG KUPANG' }
];

// Build bidirectional lookup mappings for auto-fill functionality

// Region to locations mapping
const regionToLocationsMapping = {};
vobbLocations.forEach(loc => {
  if (!regionToLocationsMapping[loc.region]) {
    regionToLocationsMapping[loc.region] = [];
  }
  regionToLocationsMapping[loc.region].push({
    chargeArea: loc.chargeArea,
    exchangeArea: loc.exchangeArea
  });
});

// Charge Area to locations mapping
const chargeAreaToLocationsMapping = {};
vobbLocations.forEach(loc => {
  if (!chargeAreaToLocationsMapping[loc.chargeArea]) {
    chargeAreaToLocationsMapping[loc.chargeArea] = [];
  }
  chargeAreaToLocationsMapping[loc.chargeArea].push({
    region: loc.region,
    exchangeArea: loc.exchangeArea
  });
});

// Exchange Area to locations mapping
const exchangeAreaToLocationsMapping = {};
vobbLocations.forEach(loc => {
  if (!exchangeAreaToLocationsMapping[loc.exchangeArea]) {
    exchangeAreaToLocationsMapping[loc.exchangeArea] = [];
  }
  exchangeAreaToLocationsMapping[loc.exchangeArea].push({
    region: loc.region,
    chargeArea: loc.chargeArea
  });
});

// Get unique lists for autocomplete dropdowns
export const uniqueRegions = [...new Set(vobbLocations.map(loc => loc.region))].sort();
export const uniqueChargeAreas = [...new Set(vobbLocations.map(loc => loc.chargeArea))].sort();
export const uniqueExchangeAreas = [...new Set(vobbLocations.map(loc => loc.exchangeArea))].sort();

// Helper functions for bidirectional auto-fill

/**
 * Get matching locations when region is selected
 * Returns the first match for auto-fill
 */
export function getLocationsByRegion(region) {
  const locations = regionToLocationsMapping[region] || [];
  if (locations.length > 0) {
    // Return first match for auto-fill
    return {
      chargeArea: locations[0].chargeArea,
      exchangeArea: locations[0].exchangeArea
    };
  }
  return { chargeArea: '', exchangeArea: '' };
}

/**
 * Get matching locations when charge area is selected
 * Returns the first match (or all matches if multiple exist)
 */
export function getLocationsByChargeArea(chargeArea) {
  const locations = chargeAreaToLocationsMapping[chargeArea] || [];
  if (locations.length > 0) {
    // Return first match for auto-fill
    return {
      region: locations[0].region,
      exchangeArea: locations[0].exchangeArea
    };
  }
  return { region: '', exchangeArea: '' };
}

/**
 * Get matching locations when exchange area is selected
 * Returns the first match (or all matches if multiple exist)
 */
export function getLocationsByExchangeArea(exchangeArea) {
  const locations = exchangeAreaToLocationsMapping[exchangeArea] || [];
  if (locations.length > 0) {
    // Return first match for auto-fill
    return {
      region: locations[0].region,
      chargeArea: locations[0].chargeArea
    };
  }
  return { region: '', chargeArea: '' };
}

/**
 * Get filtered charge areas for a specific region
 */
export function getChargeAreasByRegion(region) {
  const locations = regionToLocationsMapping[region] || [];
  return [...new Set(locations.map(loc => loc.chargeArea))].sort();
}

/**
 * Get filtered exchange areas for a specific region
 */
export function getExchangeAreasByRegion(region) {
  const locations = regionToLocationsMapping[region] || [];
  return [...new Set(locations.map(loc => loc.exchangeArea))].sort();
}

/**
 * Get filtered exchange areas for a specific charge area
 */
export function getExchangeAreasByChargeArea(chargeArea) {
  const locations = chargeAreaToLocationsMapping[chargeArea] || [];
  return [...new Set(locations.map(loc => loc.exchangeArea))].sort();
}

/**
 * Validate if a combination of region, charge area, and exchange area is valid
 */
export function isValidLocationCombination(region, chargeArea, exchangeArea) {
  return vobbLocations.some(
    loc => loc.region === region &&
           loc.chargeArea === chargeArea &&
           loc.exchangeArea === exchangeArea
  );
}

export default vobbLocations;
